/*
 * UI and display settings.
 */

import { DefaultAppStyle } from "app/styles/StyleConstants";
import { Setting, UIInputType } from "../Setting";
import i18next from "i18next";
import { ConfigurationSet } from "../Configuration";

export type PageIconOverride = Partial<{
    enabled: boolean;
    color: string;
}>;
export type PageIconOverrides = Record<string, PageIconOverride>;

export default function initUISettings(): ConfigurationSet {
    return {
        /** Notice template order */
        noticeOrder: new Setting<"title" | "template">("noticeOrder", "title", {
            uiInputType: UIInputType.Radio,

            title: i18next.t("prefs:ui.noticeOrder.title"),
            description: i18next.t("prefs:ui.noticeOrder.description"),

            validOptions: [
                {
                    name: i18next.t("prefs:ui.noticeOrder.options.title"),
                    value: "title",
                },
                {
                    name: i18next.t("prefs:ui.noticeOrder.options.template"),
                    value: "template",
                },
            ],
        }),

        /** Visible page icons */
        pageIcons: new Setting<PageIconOverrides>("pageIcons", null, {
            uiInputType: UIInputType.PageIcons,

            title: i18next.t("prefs:ui.pageIcons.title"),
            description: i18next.t("prefs:ui.pageIcons.description"),
        }),

        /** UI style */
        style: new Setting<string>("style", DefaultAppStyle, {
            uiInputType: UIInputType.Style,

            title: i18next.t("prefs:ui.style.title"),
            description: i18next.t("prefs:ui.style.description"),
        }),

        /** UI theme */
        theme: new Setting<string>("theme", null, {
            uiInputType: null, // in future, UIInputType.Theme

            title: i18next.t("prefs:ui.theme.title"),
            description: i18next.t("prefs:ui.theme.description"),
        }),

        /** Array of viewed campaigns */
        campaigns: new Setting<string[]>("campaigns", []),
    };
}
